import AppLogPagingResultModelBase from '../_generated/modelBases/app-log-paging-result-model-base';

export default class AppLogPagingResultModel extends AppLogPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
